import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Which color would you say is ")
const _hoisted_3 = { style: {"font-weight":"500"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" What would you call this color? ")
const _hoisted_6 = { class: "container-centered" }

import * as NamedColors from '../named-colors';
import * as GameTypes from 'types/game.types';
import { ref } from 'vue';
import { useModule } from 'src/modules/modules';
import GameContentArea from '../game-content-area.vue';
import ColorPicker from '../color-picker.vue';
import { capitalize, sample, clamp, shuffle } from 'lodash';
import { getColorWithSimilarityInRange } from 'util/color-util';
import { NamedColor } from 'src/types/game.types';
import NamePicker from '../name-picker.vue';
import ContrastColorText from '../contrast-color-text.vue';
import chroma from 'chroma-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'color-by-name',
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

const { game, audio } = useModule();
game.clock.stop();



const namedColor = ref<NamedColor>(game.getNamedColor(true));
const color = ref(chroma(namedColor.value.hex));
const variation = ref(1);
const state1 = ref({
    distanceMin: 49,
    distanceMax: 100,
    gridCount: 4,
    duration: 7000
})

const state2 = ref({
    duration: 7000,
    names: [] as NamedColor[]
})

const gridColors = ref<chroma.Color[]>([]);


const getNamedColor = (difficulty: 0 | 1 | 2, exclude: NamedColor[]) : NamedColor => {
    let namedColors = sample(Array.from(Object.values(NamedColors))); //Pull a random set of colors
    //let namedColors = NamedColors[`NamedColors${difficulty}`];
    let namedColor = sample(namedColors)!;
    if (exclude.find(n => n.hex === namedColor.hex)){
        return getNamedColor(difficulty, exclude);
    }
    return namedColor
}

/**
 * Assembles a set of random colors and the target color. The count is the total number of colors to return,
 * including the target color.
 */
const getNamedColorOptions = (targetColor: NamedColor, count: number) => {
    let names : NamedColor[] = []
        names.push(targetColor)
    for (let i = 0; i < (count - 1); i++){
        let namedColor = getNamedColor(<0 | 1 | 2> clamp(game.matchState.difficulty, 0, 2), names);
        names.push(namedColor);
    }
    return shuffle(names);
}

/**
 * Given a name, select a color
 */
const variation1 = () => {
    variation.value = 1;
    if (game.matchState.difficulty === 0){
        state1.value = {
            distanceMin: 49,
            distanceMax: 100,
            gridCount: 4,
            duration: 6000
        }
    } else if (game.matchState.difficulty === 1){
        state1.value = {
            distanceMin: 49,
            distanceMax: 100,
            gridCount:4,
            duration: 6000
        }
    } else if (game.matchState.difficulty === 2){
        state1.value = {
            distanceMin: 49,
            distanceMax: 100,
            gridCount: 8,
            duration: 6000
        }
    }

    for (let i = 0; i < state1.value.gridCount; i++){
        gridColors.value.push(
            getColorWithSimilarityInRange(
                color.value, 
                state1.value.distanceMin, 
                state1.value.distanceMax
            )
        );
    }

    //Randomly assign one of the grid values to our goal color.
    gridColors.value[Phaser.Math.Between(0, gridColors.value.length - 1)] = color.value;
}

/**
 * Select from a smaller number of very similar colors
 */
const variation2 = () => {
    variation.value = 2;
    if (game.matchState.difficulty === 0){
        state2.value = {
            duration: 10000,
            names: getNamedColorOptions(namedColor.value, 3)
        }
    } else if (game.matchState.difficulty === 1){
        state2.value = {
            duration: 10000,
            names: getNamedColorOptions(namedColor.value, 4)
        }
    } else if (game.matchState.difficulty === 2){
        state2.value = {
            duration: 15000,
            names: getNamedColorOptions(namedColor.value, 4)
        }
    } else if (game.matchState.difficulty >= 3){
        state2.value = {
            duration: 15000,
            names: getNamedColorOptions(namedColor.value, 5)
        }
    }
}

/**
 * Randomly select a game variation
 */
Phaser.Utils.Array.GetRandom([variation1, variation2])();


const container = ref();
const picker = ref();
const handleEnter = () => game.clock.start(variation.value === 1 ? state1.value.duration : state2.value.duration);
const handleColorSelected = async (c: chroma.Color) => {
    if (c.hex() === color.value.hex()){
        emit('next',  <GameTypes.MatchCompleteData> {
            background: c
        });
        return;
    }
    emit('fail');
}

const handleNameSelected = async (name: NamedColor, usedHint?: boolean) => {
    if (name.hex === namedColor.value.hex){
        if (usedHint) game.matchState.hintCount += 1;
        emit('next',  <GameTypes.MatchCompleteData> {
            scoreMultipliers: usedHint ? [{
                label: 'Hint Penalty',
                factor: -6
            }] : [],
            background: chroma(name.hex)
        });
        return;
    }
    emit('fail');
}

expose({
    leave: () => {
        return Promise.all([
            picker.value?.leave(),
            container?.value.leave()
        ])
    }
})

console.log(`Color By Name: Variation ${variation.value}, Difficulty ${game.matchState.difficulty}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onSkip: _cache[0] || (_cache[0] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      (variation.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(capitalize)(namedColor.value.name)), 1),
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock(ContrastColorText, {
            key: 1,
            color: _unref(chroma)(namedColor.value.hex)
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["color"]))
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        (variation.value === 1)
          ? (_openBlock(), _createBlock(ColorPicker, {
              key: 0,
              ref_key: "picker",
              ref: picker,
              colors: gridColors.value,
              onEnter: handleEnter,
              onSelect: handleColorSelected
            }, null, 8, ["colors"]))
          : (_openBlock(), _createBlock(NamePicker, {
              key: 1,
              ref_key: "picker",
              ref: picker,
              names: state2.value.names,
              "target-name": namedColor.value,
              onEnter: handleEnter,
              onSelect: handleNameSelected
            }, null, 8, ["names", "target-name"]))
      ])
    ]),
    _: 1
  }, 512))
}
}

})